/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Target_Group_HelpInputs */



/**
* | output |
* | --- |
* | "Select the group to copy timecodes to" |
*
* @param {Target_Group_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const target_group_help = /** @type {((inputs?: Target_Group_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Target_Group_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez le groupe vers lequel copier les timecodes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie die Gruppe aus, in die die Timecodes kopiert werden sollen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona il gruppo in cui copiare i codici temporali")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите группу, в которую нужно скопировать временные метки.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione el grupo al que desea copiar los códigos de tiempo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择要将时间码复制到的组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイムコードをコピーするグループを選択します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टाइमकोड कॉपी करने के लिए समूह का चयन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione o grupo para o qual deseja copiar os códigos de tempo.")
	return /** @type {LocalizedString} */ ("Select the group to copy timecodes to")
});